export const baseURL = 'https://salonslot.codderlab.com/';
// export const baseURL = 'http://192.168.1.45:5036/';
export const secretKey = '1DD4D217B557ED9523E9C9FE6C3F5';
export const projectName = 'Salon Slot';
